// feature/fallos-subviews — fallos filtered sub-view by instancia + resultado.
// Uses the new sub_tipo column from feature/tipo-taxonomy. Falls back gracefully for
// older fallos where sub_tipo is NULL.
import React, { useEffect, useMemo, useState } from "react";
import { cases as casesApi } from "../../api/endpoints";
import Spinner from "../../components/Spinner";
import Empty from "../../components/Empty";
import CaseDetail from "../case-detail";
import { ESTADO_LABEL } from "../../components/Pills";

const fmt = (d) => d ? new Date(d).toLocaleString("es-CO") : "—";

const TITLES = {
  "primera-favorable":    "Fallos primera instancia · Favorables",
  "primera-desfavorable": "Fallos primera instancia · Desfavorables",
  "segunda-favorable":    "Fallos segunda instancia · Favorables",
  "segunda-desfavorable": "Fallos segunda instancia · Desfavorables",
  historico:              "Fallos · Histórico",
};

export default function FallosFiltered({ instancia, resultado, mode }) {
  const key = mode === "historico" ? "historico" : `${instancia}-${resultado}`;
  const title = TITLES[key] || "Fallos";
  const [data, setData] = useState(null);
  const [openId, setOpenId] = useState(null);

  function load() {
    setData(null);
    casesApi.list({ tipo: "fallo" })
      .then(r => setData(r.data))
      .catch(() => setData([]));
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [mode, instancia, resultado]);

  const rows = useMemo(() => {
    if (!data) return [];
    if (mode === "historico") {
      return data.filter(c => c.estado === "cerrado"
        || c.estado === "fallo_decidido_impugnar"
        || c.estado === "fallo_decidido_no_impugnar");
    }
    // feature/fallos-workflow-inversion. Both legacy
    // fallo_pendiente_revision and new pendiente_revision_impugnacion show in
    // Molly's pending lists.
    return data.filter(c =>
      (c.estado === "fallo_pendiente_revision"
       || c.estado === "pendiente_revision_impugnacion")
      && c.instancia === instancia
      && c.resultado === resultado
    );
  }, [data, mode, instancia, resultado]);

  return (
    <div className="col" style={{ gap: 16 }}>
      <h1 style={{ margin: 0 }}>{title}</h1>

      <div className="card" style={{ padding: 0 }}>
        {data == null ? (
          <div style={{ padding: 32, textAlign: "center" }}><Spinner size={20} /></div>
        ) : !rows.length ? (
          <Empty title="Sin fallos en esta categoría" message="Cuando Reparto registre uno, aparecerá aquí." />
        ) : (
          <table>
            <thead>
              <tr>
                <th>Caso</th><th>Accionante</th><th>Radicado</th>
                <th>Juzgado</th><th>Fecha de ingreso</th><th>Estado de la actuación</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(c => (
                <tr key={c.id} onClick={() => setOpenId(c.id)} style={{ cursor: "pointer" }}>
                  <td><strong>{c.case_number}</strong></td>
                  <td>{c.accionante_nombre || "—"}</td>
                  <td>{c.radicado}</td>
                  <td>{c.juzgado || "—"}</td>
                  <td>{fmt(c.fecha_ingreso)}</td>
                  <td>{ESTADO_LABEL[c.estado] || c.estado}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <CaseDetail
        caseId={openId} open={!!openId}
        defaultTab={mode === "historico" ? "general" : "decision"}
        onClose={() => setOpenId(null)}
        onChanged={load}
      />
    </div>
  );
}
